import React, { Component } from "react";
import {InputGroup, Input } from '@chakra-ui/react'

import Decimal from "decimal.js";

import CardUtils from "../Models/CardUtils";





export default class CompositeCountInput extends Component 
{
    constructor(props)
    {
        super(props);

        this.state = {
          valid: false
        }

        this.onValueChange = this.onValueChange.bind(this);
        this.onValidityCheck = this.onValidityCheck.bind(this);

    }


    onValueChange(ev) {
        let containerCount = this.props.valueBag[CardUtils.titleToId(this.props.card.containerCountTitle)];
        let containerQty = this.props.valueBag[CardUtils.titleToId(this.props.card.containerQtyTitle)]; //this.state.containerQty;
        let unitQty = this.props.valueBag[CardUtils.titleToId(this.props.card.unitQtyTitle)]; //this.state.unitQty;
        if (ev.target.id === "containerCount") {
          containerCount = ev.target.value;
          this.props.onValueChange(containerCount, CardUtils.titleToId(this.props.card.containerCountTitle));
        }
        else {
          containerQty = ev.target.value;
          this.props.onValueChange(containerQty, CardUtils.titleToId(this.props.card.containerQtyTitle));
        }
        if ((Number.isInteger(+containerCount)) && (Number.isInteger(+containerQty))) {
          unitQty = containerCount * containerQty;
          console.log("RESULT END: " + unitQty)
          this.props.onValueChange(unitQty, CardUtils.titleToId(this.props.card.unitQtyTitle));
          this.props.onValueChange(unitQty, this.props.card.id); // set the actual card ID value
        } else {
          console.log("ATTEMPTING FLOAT MATH")
          if ( (containerCount) && (!isNaN(containerCount)) && (containerQty) && (!isNaN(containerQty)))
            {
              unitQty = Decimal(containerQty).times(containerCount)
              console.log(unitQty)
              console.log("MATH FLOAT END")
    
              unitQty = unitQty.toDP(2)
              unitQty = unitQty.toString()
              this.props.onValueChange(unitQty, CardUtils.titleToId(this.props.card.unitQtyTitle));
              this.props.onValueChange(unitQty, this.props.card.id); // set the actual card ID value
            }
            else
            {
              unitQty = 0;
            }
        }
        this.onValidityCheck(unitQty);
        this.setState({
          containerCount: containerCount,
          containerQty: containerQty,
          unitQty: unitQty
        });
      }

      onValidityCheck(unitQty)
      {
        if ((this.props.card.validation) && (this.props.card.validation.required)) 
        {
          var isValid = ((unitQty) && (unitQty>0));
          if (isValid !== this.state.valid)
          {
            // validity state has changed!
            this.setState({valid: isValid});
            // in this case, we want the actual validation id to the unitQty value
            this.props.onValidationChange(CardUtils.titleToId(this.props.card.unitQtyTitle), isValid, this.props.card.validation.requiredMessage);
          }
    
        }
      }



    render() 
    {
        return(                

            <InputGroup style={{padding: "25px"}}>
                <Input
                    autoFocus="true"
                    backgroundColor={"white"}
                    textAlign="center"
                    placeholder={this.props.card.containerCountTitle}
                    id="containerCount"
                    name={CardUtils.titleToId(this.props.card.containerCountTitle)}
                    value={this.props.valueBag[CardUtils.titleToId(this.props.card.containerCountTitle)]}
                    onChange={(ev) => {this.onValueChange(ev)}}
                />


            <span>&nbsp;x&nbsp;</span>

                <Input
                    backgroundColor={"white"}
                    textAlign="center"
                    placeholder={this.props.card.containerQtyTitle}
                    id="containerQty"
                    name={CardUtils.titleToId(this.props.card.containerQtyTitle)}
                    value={this.props.valueBag[CardUtils.titleToId(this.props.card.containerQtyTitle)]}
                    onChange={(ev) => {this.onValueChange(ev)}}
                />

            <span>&nbsp;=&nbsp;</span>

                <Input
                    backgroundColor={"white"}
                    textAlign="center"
                    placeholder={this.props.card.unitQtyTitle}
                    id="unitQty"
                    name={CardUtils.titleToId(this.props.card.unitQtyTitle)}
                    value={this.props.valueBag[CardUtils.titleToId(this.props.card.unitQtyTitle)]}
                    onChange={(ev) => {this.onValueChange(ev)}}
                />

          </InputGroup>


        )
    }
}







